import styled from 'styled-components';
import { typography } from 'dab-component-lib';
import { BackStyle, GridRowStyle, GridColStyle, MediaStyle, basic } from '../../utils/style-utils';


export const BackStyleHeader = BackStyle.extend`
  display: inline-block;
  margin-top: 15px;
`;

export const OrderRowStyle = GridRowStyle.extend`
  flex-direction: column;
  display: block;
  ${ MediaStyle.md`
    display: flex;
    flex-direction: row;
    flew-wrap: nowrap;
    margin-top: 15px;
  ` }
`;

export const OrderColStyle = GridColStyle.extend`
  ${ MediaStyle.md`
    width: ${props => props.third ? '40%' : 'auto'};
    margin: ${props => props.third ? '0 0 0 15px' : '0 15px 0 0'};
    flex: ${props => props.third && 'none'};
    flex-grow: ${props => !props.third && '1'};
    flex-shrink: ${props => !props.third && '1'};
    flex-basis:${props => !props.third && '0'}; 
  ` }
`;

export const CartItemWrapper = styled.div`
  margin-bottom: 15px;
`;

export const ActionsRowStyle = styled.div`
  margin-top: 15px;
  ${ MediaStyle.md`
    display: flex;
    justify-content: space-between;
    align-items: center;
  ` }
`;

export const PdfButtonStyle = styled.div`
  display: flex;
  align-items: center;
  ${ MediaStyle.smOnly`
    margin-bottom: 20px;
  ` }
`;

export const LabelStyle = styled.label`
  ${typography.Body2};
  margin-left: 5px;
`;

export const OrderNotesWrapperStyle = styled.div`
  textarea {
    max-width: none;
  }
`;

export const ButtonWrapperStyle = styled.div`
  text-align: right;
  margin-top: 10px;
`;

export const OrderNotesStyle = styled.div`
  display: flex;
  ${typography.Body2};
  color: ${basic.secondary};
  margin: 30px 0 10px;
  cursor: pointer;
  span {
    display: inline-block;
    margin-left: 10px;
  }
  ${ MediaStyle.md`
    margin: 30px 0;
  `}
`;

export const BasketBaseStyle = styled.div`
  box-sizing: border-box;
  text-align: left;
  padding: 20px;
  background-color: ${basic.greyGreen};
  margin-bottom: 20px;
`;

export const BasketNameStyle = styled.h3`
  ${typography.Title1}
`;


// WEBPACK FOOTER //
// ./src/components/orderSummary/style.js